import * as types from '../actions/action-types';
import _ from 'lodash';
import conf from 'config/app-config';

const initialState = {
    assets: null,
    buffer: [],
};

function extractAsset(asset) {
    let {title, keywords, caption, url, urlCdn, assetUUID, posterUrl :
        poster, uploadStatus, thumbnail256x144Url : thumbnail, creationDate, duration, fileSize} = asset.metadata;
    let isVideo = (asset.metadata.assetType === 'VIDEO');
    let isGif = (asset.metadata.assetType === 'GIF');

    let computedAsset = { thumbnail, assetUUID, isVideo, isGif, url, urlCdn, poster, uploadStatus, title, caption, keywords, creationDate,
        duration, fileSize};

    if (isGif) {
        computedAsset.animatedGifUrl = asset.metadata && asset.metadata.animatedGifUrl;
    }

    return computedAsset;
}

function extractAssets(assets) {
    if (assets === null) {
        return [];
    }

    return assets.map(asset => {
        return extractAsset(asset);
    });
}

const assetReducer = function(state = initialState, action) {

    let assets, asset, buffer;
    const {initialPageSize, bufferSize} = conf.scroll;
    switch(action.type) {
        case types.GET_ASSETS_SUCCESS:
            assets = extractAssets(action.assets);
            const uploadingAssets = _.filter(state.assets, asset => !!asset.file);
            const first = assets.slice(0, initialPageSize);
            buffer = assets.slice(initialPageSize, initialPageSize + bufferSize);
            return Object.assign({}, state, {assets: uploadingAssets.concat(first), buffer});

        case types.REFILL_BUFFER:
            buffer = extractAssets(action.assets);
            return Object.assign({}, state, {buffer});

        case types.GET_ASSETS_FROM_BUFFER:
            assets = [...state.assets, ...state.buffer];
            buffer = [];
            return Object.assign({}, state, {assets, buffer});

        case types.ADD_UPLOADING_ASSETS:
            assets = [...action.files, ...state.assets];
            return Object.assign({}, state, {assets});

        case types.ASSET_ERROR:
            assets = Array.from(state.assets);
            asset = _.find(assets, asset => asset.assetUUID === action.assetId);
            if (_.isEmpty(asset)) {
                return state;
            }
            asset.errors = asset.errors || {};
            asset.errors[action.errorCode] = action.errorMessage;
            return Object.assign({}, state, {assets});

        case types.ASSET_UPDATE_PROGRESS:
            assets = Array.from(state.assets);
            if (action.progress === 'UPLOADING') {
                asset = _.find(assets, asset => asset.tempUUID === action.assetId);
                if (_.isEmpty(asset)) {
                    return state;
                }
                asset.assetUUID = action.permanentUUID;
                delete asset.tempUUID;
            } else {
                asset = _.find(assets, asset => asset.assetUUID === action.assetId);
            }

            if (_.isEmpty(asset)) {
                return state;
            }

            asset.uploadStatus = action.progress;
            return Object.assign({}, state, {assets});

        case types.ASSET_PERCENT_COMPLETE:
            assets = Array.from(state.assets);
            asset = _.find(assets, asset => asset.assetUUID === action.assetId);
            if (_.isEmpty(asset)) {
                return state;
            }

            asset.percentComplete = action.percentComplete;
            return Object.assign({}, state, {assets});

        case types.GET_ASSET_METADATA:
            assets = Array.from(state.assets);
            asset = _.find(assets, asset => asset.assetUUID === action.assetId);
            if (_.isEmpty(asset)) {
                return state;
            }
            asset.assetUUID = action.newUUID;
            asset.uploadId = action.uploadId;
            return Object.assign({}, state, { assets });

        case types.UPLOAD_ASSET_DONE:
            assets = Array.from(state.assets);
            asset = _.find(assets, asset => asset.assetUUID === action.assetId);
            if (_.isEmpty(asset)) {
                return state;
            }
            window.URL.revokeObjectURL(asset.url);
            asset.uploadStatus = 'DONE';
            asset.urlCdn = action.asset.urlCdn;
            asset.url = action.asset.url;
            asset.poster = action.asset.posterUrl;
            if (_.isEmpty(asset.thumbnail)) {
                asset.thumbnail = action.asset.thumbnail;
            }
            delete asset.file;
            return Object.assign({}, state, { assets });

        case types.DELETE_ASSET_SUCCESS:

            // Use lodash to create a new user array without the asset we want to remove
            assets = [...state.assets];
            _.remove(assets, asset => (asset.assetUUID === action.assetId || asset.tempUUID === action.assetId));
            return Object.assign({}, state, {assets});

        case types.CLEAR_ASSETS:
            return Object.assign({}, state, { assets: null });
        default:
            return state;

    }

};

export default assetReducer;
